import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import SectionHeading from "./SectionHeading";
import CuratePreview from "../curate/CuratePreview";

export default function CurateSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // Side by side (desktop), the first preview arrives with the heading; on
  // mobile the previews sit below the description, so they wait for their
  // own scroll rather than playing off-screen
  const [headingAssembled, setHeadingAssembled] = useState(false);
  return (
    <Grid
      container
      spacing={8}
      sx={{
        maxWidth: "lg",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={12}
        md={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <SectionHeading
          icon="curate"
          onAssemble={() => setHeadingAssembled(true)}
          title=<b>Curate</b>
          justifyContent={{ xs: "center", md: "flex-start" }}
        />

        <Box
          maxWidth="250px"
          sx={{
            my: 0,
            position: "relative",
            // border: "1px solid blue",
          }}
        >
          <Typography sx={{ mb: 1.5 }}>
            Curate the films, books and shows you love into collections that
            reflect your taste.
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            Build or borrow. Create your own or save collections from friends
            and the community.
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            Progress, built in. See at a glance how far you've gotten through
            every collection.
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            One tap, anywhere. See a cover you like while browsing? Simply tap
            to track.
          </Typography>

          <Typography sx={{ fontStyle: "italic", textWrap: "balance" }}>
            Check these out to get a feel for how it works{" "}
            {isMobile ? "👇" : "👉"}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={9} sx={{ mt: { xs: -4, md: 0 } }}>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <CuratePreview
            firstInView={isMobile ? undefined : headingAssembled}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
